module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@3x-1073df7395657a815a5167a7bed05e84.png";